import { render, staticRenderFns } from "./TeacherContactList.vue?vue&type=template&id=05d985ca&scoped=true"
import script from "./TeacherContactList.vue?vue&type=script&lang=js"
export * from "./TeacherContactList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05d985ca",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('05d985ca')) {
      api.createRecord('05d985ca', component.options)
    } else {
      api.reload('05d985ca', component.options)
    }
    module.hot.accept("./TeacherContactList.vue?vue&type=template&id=05d985ca&scoped=true", function () {
      api.rerender('05d985ca', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/school/mentalHealth/DynamicMonitor/components/TeacherContactList.vue"
export default component.exports